module.exports = __webpack_public_path__ + "img/logo-shanrise-opc.bb03b870.png";